import { __assign } from "tslib";
import { getPrecisionForInterval, createDateFormatter, } from '@keen.io/charts-utils';
import { extractOrderDirection } from '../query';
export var setChartSettings = function (_a) {
    var query = _a.query, componentSettings = _a.componentSettings;
    var interval = query.interval, orderBy = query.order_by;
    var settings = {};
    var barChartSettings = componentSettings;
    if (barChartSettings.stackMode === 'percent') {
        settings = {
            yScaleSettings: {
                formatLabel: '${}%',
            },
        };
    }
    if (interval) {
        var precision = getPrecisionForInterval(interval);
        var dateFormatter = createDateFormatter(precision);
        settings = __assign(__assign({}, settings), { tooltipSettings: {
                formatTime: dateFormatter,
            }, xScaleSettings: {
                type: 'time',
                precision: precision,
                formatLabel: dateFormatter,
            } });
    }
    if (orderBy) {
        settings = __assign(__assign({}, settings), { barsOrder: extractOrderDirection(orderBy) });
    }
    return settings;
};
